import { render, staticRenderFns } from "./SubmissionWidget.vue?vue&type=template&id=01f65bff&scoped=true"
import script from "./SubmissionWidget.vue?vue&type=script&lang=js"
export * from "./SubmissionWidget.vue?vue&type=script&lang=js"
import style0 from "./SubmissionWidget.vue?vue&type=style&index=0&id=01f65bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f65bff",
  null
  
)

export default component.exports